/*  ========================================================================
    # Offer
    ========================================================================  */

const Offer = {
  cfg: {
    modal: {
      container: document.querySelector('.p-offer__modal'),
      contentClose: document.querySelector('.p-offer__modal-content-close'),
      contentButton: document.querySelector('.p-offer__modal-content-button .c-button')
    },
    content: document.querySelector('.p-offer__content')
  },

  /**
   * Sets whether the modal is currently open.
   *
   * @param {boolean} isOpen
   */
  setModalOpen(isOpen) {
    if (isOpen) {
      this.cfg.modal.container.showModal();
      this.cfg.modal.contentButton.focus();
    }
    if (!isOpen) {
      this.cfg.modal.container.close();
    }
  },

  /**
   * Sets the link of the modal button.
   *
   * @param {string} url
   */
  setModalLink(url) {
    this.cfg.modal.contentButton.href = url;
  },

  /**
   * Default behavior of the modal.
   */
  modal() {
    this.cfg.modal.contentClose.addEventListener('click', () => {
      this.setModalOpen(false);
    });
  },

  /**
   * Checks if there are external links within the content. If so, the link will
   * not open directly, but instead a modal appears indicating that an external
   * website will be opened.
   */
  handleExternalLinks() {
    this.cfg.content.querySelectorAll('a').forEach(link => {
      const isExternalLink = link.href && link.href.startsWith('http') && !link.href.includes('evm.de');
      if (!isExternalLink) {
        return;
      }
      link.addEventListener('click', event => {
        event.preventDefault();
        this.setModalOpen(true);
        this.setModalLink(link.href);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    this.modal();
    this.handleExternalLinks();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  Offer.init();
});
